import {
  ColOptions,
  ColSize,
  ColSpace,
  ScreenMediaSize,
} from 'src/app/shared/basic/ds-col/ds-col.component';
import {
  DsTableColumnConfig,
  DsTableColumnDisplayPosition,
  DsTableColumnFormatEnum,
  DsTableColumnSizeEnum,
} from './TableColumnConfig';
import { TABLE_COLUMNS_KEY } from './ds-table.component';

export function DsTableColumn(config?: {
  key?: string;
  label?: string;
  format?: DsTableColumnFormatEnum;
  displayPosition?: DsTableColumnDisplayPosition;
  sequence?: number;
  displayProperty?: string;
  size?: DsTableColumnSizeEnum;
  responsiveSize?: ColOptions;
  override?: DsTableColumnOverrideEnum;
}) {
  return function (target: any, propertyKey: string) {
    const existing =
      (Reflect.getMetadata(
        TABLE_COLUMNS_KEY,
        target.constructor
      ) as DsTableColumnConfig[]) || [];

    const propertyMetadata = {
      key: config.key,
      label: config?.label ?? propertyKey,
      property: propertyKey,
      modelType: target.constructor.name,
      displayProperty: config?.displayProperty,
      format: config?.format ?? DsTableColumnFormatEnum.Text,
      displayPosition:
        config?.displayPosition ?? DsTableColumnDisplayPosition.Header,
      size: config?.size,
      sequence: config?.sequence ?? 0,
      responsiveSize:
        config?.responsiveSize ?? DsTableColumnResponsiveSizeFactory.default,
      override: config?.override ?? DsTableColumnOverrideEnum.Override,
    };

    existing.push(propertyMetadata);

    Reflect.defineMetadata(TABLE_COLUMNS_KEY, existing, target.constructor);
  };
}

export function getClassParentNames(ctor: Function): string[] {
  const parents: string[] = [];
  let proto = Object.getPrototypeOf(ctor.prototype);

  while (proto && proto.constructor !== Object) {
    parents.push(proto.constructor.name);
    proto = Object.getPrototypeOf(proto);
  }

  return parents;
}

export function DsTableLookupColumn(config?: {
  key?: string;
  label?: string;
  displayPosition?: DsTableColumnDisplayPosition;
  sequence?: number;
  displayProperty?: string;
  size?: DsTableColumnSizeEnum;
  responsiveSize?: ColOptions;
  override?: DsTableColumnOverrideEnum;
}) {
  return DsTableColumn({ format: DsTableColumnFormatEnum.Lookup, ...config });
}

export class DsTableColumnResponsiveSizeFactory {
  public static get default(): ColOptions {
    return {
      maximumSize: {
        colSpace: ColSpace.Third,
        screenMediaSize: ScreenMediaSize.Medium,
      },
      minimumSize: {
        colSpace: ColSpace.Full,
        screenMediaSize: ScreenMediaSize.Small,
      },
      renderAs: 'self',
    };
  }
}

export enum DsTableColumnOverrideEnum {
  Override = 'override',
  Hide = 'hide',
}
